import { RootState } from '@app/store';

// TODO move the rest of the auth selectors here. these were moved here to remove
// a circular depedency between authSlice.ts and siteSlice.ts
//
// be careful on importing types and other functions here, it could easily just as
// well create more circular dependencies
export const selectFilteredSiteList = (state: RootState) =>
  state.auth.filteredSiteList;
export const selectSiteList = (state: RootState) => state.auth.siteList;

// used internally
export const selectSiteId = (_state: RootState, siteId: number) => siteId;
